/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerBundleProjectSightDrawingsMutationResponse, TrimbleItemsControllerBundleProjectSightDrawingsQueryParams } from "../../models/trimbleController/TrimbleItemsControllerBundleProjectSightDrawings";

function getTrimbleItemsControllerBundleProjectSightDrawingsUrl() {
  const res = { method: 'POST', url: `/api/v1/trimble/projectsight/drawings/bundle` as const }  
  return res
}

/**
 * @summary Merge selected ProjectSight drawings into one PDF, in sheet order
 * {@link /api/v1/trimble/projectsight/drawings/bundle}
 */
export async function trimbleItemsControllerBundleProjectSightDrawings(params: TrimbleItemsControllerBundleProjectSightDrawingsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleItemsControllerBundleProjectSightDrawingsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getTrimbleItemsControllerBundleProjectSightDrawingsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}